import {
  PRODUCT_CATEGORY,
  Purchases,
  PURCHASES_ERROR_CODE,
} from '@revenuecat/purchases-capacitor'

export const purchase = async (
  productId: string,
  apiKey: string,
  userId?: string,
  isSubscription?: boolean,
  t?: (key: string) => string
) => {
  await Purchases.configure({ apiKey, appUserID: userId })

  const product = await Purchases.getProducts({
    productIdentifiers: [productId],
    type: isSubscription
      ? PRODUCT_CATEGORY.SUBSCRIPTION
      : PRODUCT_CATEGORY.NON_SUBSCRIPTION,
  })

  if (!product?.products || product.products.length === 0) {
    throw new Error(t && t('iapProductNotPurchasable'))
  }

  const res = await Purchases.purchaseStoreProduct({
    product: product.products[0],
  }).catch(e => {
    if (e?.code === PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR) {
      // ユーザーによる明示的なキャンセル
      throw new Error(t && t('iapPurchaseCanceled'))
    } else {
      throw new Error(e?.error?.messsage ?? (t && t('iapPaymentFailed')))
    }
  })

  return res
}
